import React from "react";
export const Landing = () => {
    return (
      <div className="relative flex flex-col-reverse py-16 lg:pt-0 lg:flex-col lg:pb-0 bg-sky-50">
        <div className="inset-y-0 top-0 right-0 z-0 w-full max-w-xl px-4 mx-auto md:px-0 lg:pr-0 lg:mb-0 lg:mx-0 lg:w-7/12 lg:max-w-full lg:absolute xl:px-0 ">
          <svg
            className="absolute left-0 hidden h-full text-white transform -translate-x-1/2 lg:block"
            viewBox="0 0 100 100"
            fill="currentColor"
            preserveAspectRatio="none slice"
          >
            <path d="M50 0H100L50 100H0L50 0Z" />
          </svg>
          <img
            className="object-cover w-full h-56 rounded shadow-lg lg:rounded-none lg:shadow-none md:h-96 lg:h-full"
            src="https://www.claro.com.co/portal/co/noticias/imagenes/1622208712077-7-Caracteristicas-de-los-computadores-de-videojuegos.jpg"
            alt=""
          />
        </div>
        <div className="relative flex flex-col items-start w-full max-w-xl px-4 mx-auto md:px-0 lg:px-8 lg:max-w-screen-xl ">
          <div className="mb-16 lg:my-40 lg:max-w-lg lg:pr-5">
            <p className="inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-teal-accent-400">
            </p>
            <h2 className="font text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
              Lo nuevo en tecnologia{' '}
              <br className="hidden md:block" />
              esta finalmente{' '}
              <span className="inline-block text-deep-purple-accent-400">
                aqui
              </span>
              
            </h2>
            <br className="hidden md:block" />

            <p className="text-base text-gray-700 md:text-lg">
            Los mejores productos de tecnologia con las mejores promociones ya estan a tu alcance.
            </p>
            <br className="hidden md:block" />

            <div className="flex items-center">
              <a
                  href="/home"
                  className="inline-block rounded-md border border-transparent bg-blue-500 py-3 px-8 text-center font-medium text-white hover:bg-blue-700"
                >
                  Descubre aqui
                </a>
            </div>
          </div>
        </div>
      </div>
    );
  };